// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"styles_numberInput__3DYFo"};